import { useAsyncState, type MaybeRef } from '@vueuse/core';
import { unref } from 'vue';
import { FileHelper } from '@getaccept/lib-shared/src/file/helpers/file.helper';
import type { QesFileType } from '@getaccept/lib-shared/src/qes/enums/qes-file-type';
import { useToast } from '@getaccept/fried-tofu';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { QesService } from '../../documents/qes/services/qes.service';
import { UploadFileService } from '../../api/upload-files/services/upload-file.service';
import { CreateDocumentService } from '../services/create-document.service';
import { DocumentService } from '../../api/documents/services/document.service';

export const useCreateQesFile = (documentId: MaybeRef<string>) => {
  const nameMaxLength = 50;

  const uploadToS3 = async ({ url, stringifiedFields }, fileType: QesFileType, file: File) => {
    const headers = JSON.parse(stringifiedFields);
    headers['Content-Type'] = `application/${fileType}`.toLocaleLowerCase();

    const payload = { file, uploadLink: url, headers };
    await UploadFileService.uploadFile(payload);
  };

  const upload = async (file: File, qes: boolean) => {
    try {
      if (!qes) {
        await CreateDocumentService.updateDocument(unref(documentId), { isSelfsign: 0 });
        await DocumentService.updateDocumentQES(unref(documentId), true);
      }
      const fileType = FileHelper.getFileType(file.name) as QesFileType;
      const name = FileHelper.removeExtension(file.name).substring(0, nameMaxLength);

      const fileId = await QesService.createQesFile(unref(documentId), fileType, name);
      const uploadLink = await QesService.getUploadLink(unref(documentId), fileId);
      uploadToS3(uploadLink, fileType, file);
    } catch {
      useToast().toast.danger(t('qes_file_upload_failed'));
    }
  };
  return useAsyncState((file: File, qes: boolean) => upload(file, qes), null, {
    immediate: false,
  });
};
